import { ChangeEvent } from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { CompanyType } from "$types";
import { getCompanyTypeLabel } from "$utils/typeConstants";
import JTooltip from "$components/JTooltip/JTooltip";

type Props = {
  companyType: CompanyType;
  checked: boolean;
  disabled: boolean;
  disabledMessage: string;
  onChange: (newCompanyTypes: CompanyType[]) => void;
  value: CompanyType[];
};

function CompanyTypeCheckbox({
  companyType,
  checked,
  disabled,
  disabledMessage,
  onChange,
  value,
}: Props) {
  return (
    <JTooltip
      placement="right"
      title={disabled && disabledMessage}
      hasNestedTooltips={false}
    >
      <FormControlLabel
        key={companyType}
        checked={checked}
        disabled={disabled}
        control={<Checkbox color="primary" />}
        label={getCompanyTypeLabel(companyType)}
        value={companyType}
        onChange={(event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
          if (checked) {
            onChange([...value, event.target.value as CompanyType]);
          } else {
            onChange(value.filter((v) => v !== event.target.value));
          }
        }}
        // if not provided, the FormControlLabel is full width and push the Tooltip far away
        style={{ width: "fit-content" }}
      />
    </JTooltip>
  );
}

export default CompanyTypeCheckbox;
